import axios from "axios";

export class Eventos {
    static lasts (idResidencia) {
        return axios.post("/eventos/lasts", {
            id_residencia: idResidencia
        });
    }
    static lastsApos (idResidencia, idTransmissao) {
        return axios.post("/eventos/lasts-before", {
            id_residencia: idResidencia,
            id_transmissao: idTransmissao
        });
    }
}
